export default {
    namespaced : true,
    state:{
        drawer : false,
    },
    // getters:{
    //     drawer: state => {
    //         return state.drawer
    //     }
    // },
    mutations: {
        TOGGLE_SIDEBAR(state){
            state.drawer = !state.drawer
        }
    },
    actions: {
        toggleSidebar(context){
            context.commit('TOGGLE_SIDEBAR')
        }
    }
}